import React, { useState, useEffect, Suspense } from "react";
import DropWindow from "./../components/DropWindow";
import { useContent } from "../i18n/useContent";

function Open() {
  const [dropdown, setDropdown] = useState("");
  const Content = useContent('open');

  function getOpen() {
    setDropdown("open");
  }

  useEffect(() => {
    getOpen();
  }, []);

  return (
    <DropWindow dropdown={dropdown} setDropdown={setDropdown}>
      <Suspense fallback={<div>...</div>}>
        <Content />
      </Suspense>
    </DropWindow>
  );
}

export default Open;
